import { memo, useMemo } from 'react';
import { IoBusinessOutline } from 'react-icons/io5';
import { parseTime } from '../../../../helpers/timeHelpers';
import {
  IDetailProfileInfoFC as ISchoolProps,
  UserSettingEnum,
} from '../../../../interfaces/profile.interface';
import ProfileInfoEditButton from '../button/ProfileInfoEditButton';

const SchoolComponent: React.FC<ISchoolProps> = ({
  data,
  roleView,
  setModal,
}) => {
  const item = useMemo(() => data, [data]);

  return (
    <div className="group flex justify-between items-start">
      <span className="mt-2">
        <div className="bg-blur_primary rounded-full p-2">
          <IoBusinessOutline className="text-primary text-[16px]" />
        </div>
      </span>
      <div className="w-full mx-4 overflow-hidden">
        <p className="text-primary_black text-[14px] break-words">
          {item.schoolName}
        </p>
        <p className="text-[#979797] text-[12px] break-words">{item.major}</p>
        {item.startDate && parseTime(item.startDate, item.endDate)}
      </div>
      <div className="block lg:hidden group-hover:block">
        <ProfileInfoEditButton
          value={item}
          roleView={roleView}
          modalName={UserSettingEnum.School}
          setModal={setModal}
        />
      </div>
    </div>
  );
};

export default memo(SchoolComponent);
